import {type Operation} from '../state/graphql/apolloLinkRuntime';

// Marks a re-issued request as a retry so the backend can split its
// graphql.operation.{success,failed} metrics into retry vs first-attempt
// traffic (see gorilla's relay handler).
export const RETRY_ATTEMPT_HEADER = 'x-wandb-retry-attempt';

export const stampRetryHeader = (
  operation: Operation,
  attempt: number
): void => {
  operation.setContext(
    ({headers = {}}: {headers?: {[key: string]: string}}) => ({
      headers: {
        ...headers,
        [RETRY_ATTEMPT_HEADER]: String(attempt),
      },
    })
  );
};
